<script>
  import ImageGrid from "$lib/components/ImageGrid.svelte";
  import Carousel from "$lib/components/Carousel.svelte";

  export let data;
  let { images, configuration, displayCaption } = data.fields;
</script>

<div class="embedded-content">
  {#if configuration === "grid"}
    <ImageGrid {images} {displayCaption} />
  {:else if configuration === "carousel"}
    <Carousel {images} {displayCaption} />
  {:else}
    <!-- TODO: not implemented!  -->
  {/if}
</div>
